import { Link, Syringe } from "lucide-react";

export const TAB_OPTIONS = [
  { value: "system", label: "System Vaccines", icon: <Syringe size={16} /> },
  { value: "healthlink", label: "Healthlink Vaccines", icon: <Link size={16} /> },
];

export const EMPTY_CONFIRM_DIALOG = {
  isOpen: false,
  title: "",
  message: "",
  confirmLabel: "Confirm",
  confirmVariant: "primary",
  onConfirm: () => {},
};
